import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VuexPersistence from 'vuex-persist'
import { globalStore } from '@/main'

Vue.use(Vuex)

const vuexPersist = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({implementations: state.implementations, currentImplementationId: state.currentImplementationId, authToken: state.authToken}),
  filter: mutation => (mutation.type === 'setImplementations' || mutation.type === 'setCurrentImplementation' || mutation.type === 'setAuthToken' || mutation.type === 'clearAuthToken')
})

export default new Vuex.Store({
  state: {
    implementations: [],
    currentImplementationId: 0,
    authToken: null
  },
  mutations: {
    setImplementations: function (state, payload) {
      state.implementations = payload
    },
    setCurrentImplementation: function (state, newImplementationId) {
      state.currentImplementationId = newImplementationId
    },
    setAuthToken: function (state, authToken) {
      state.authToken = authToken
      
      // update token
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + authToken
    },
    clearAuthToken: function (state) {
      state.authToken = null
    }
  },
  actions: {
    fetchImplementationsList: function ({ commit }) {
      return new Promise((resolve) => {
        axios.get(globalStore.API_BASE_URL + 'api/admin-implementations').then((response, reject) => {
          let responseData = response.data
          if (responseData.code === 200) {
            commit('setImplementations', responseData.data)
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    changeCurrentImplementation: function ({ commit }, newImplementationId) {
      return new Promise((resolve) => {
        commit('setCurrentImplementation', newImplementationId)
        resolve()
      })
    },
    loginUser: function ({ commit }, authData) {
      return new Promise((resolve, reject) => {
        axios.post(globalStore.API_BASE_URL + 'admin-login', {
          email: authData.email,
          password: authData.password
        }).then((response) => {
          let responseData = response.data
          if (responseData.code === 200 && responseData.data && responseData.data.api_key) {
            commit('setAuthToken', responseData.data.api_key)
            resolve()
          } else {
            reject(responseData)
          }
        })
      })
    },
    logoutUser: function ({ commit }) {
      return new Promise((resolve) => {
        commit('clearAuthToken')
        resolve()
      })
    }
  },
  getters: {
    getAxiosConfig: function (state, getters) {
      return {
        headers: {
          "Implementation-Id": getters.getActiveImplementation
        }
      }
    },
    getImplementationsList: function (state) {
      let formatted = []
      state.implementations.forEach((implementation) => {
        let impl = {
          value: implementation.id,
          text: implementation.name + ' ('+ implementation.company +')'
        }
        formatted.push(impl)
      })
      return formatted
    },
    getActiveImplementation: function (state, getters) {
      if (getters.getImplementationsList[0]) {
        return state.currentImplementationId !== 0 ? state.currentImplementationId : getters.getImplementationsList[0].value
      }
      return state.currentImplementationId
    },
    isUserLoggedIn: function (state) {
      return state.authToken !== null ? true : false
    },
    getAuthToken: function (state) {
      return state.authToken
    }
  },
  plugins: [vuexPersist.plugin]
})
